var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import withForm from './withForm'; // A convenience wrapper around the button to submit the from. The onSubmit
// prop is called with the button is clicked and the form is valid.
export var createSubmitButton = withForm(undefined, function (formActions) { return ({
    submitForm: formActions.submitForm
}); }, function (_, formActions, props) {
    var onSubmit = props.onSubmit, validateBeforeSubmit = props.validateBeforeSubmit;
    return __assign(__assign({}, props), { 
        // The errors from submit are swallowed to prevent an unhandled promise reject. Note that using
        // this button means any errors retuned will be ignored.
        onClick: function () { return formActions.submitForm(onSubmit, {
            validateBeforeSubmit: validateBeforeSubmit
        }).catch(function (__) { return undefined; }); } });
}); // A Submit button that just wraps the default button element.
export default createSubmitButton('button');
